var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"500px","height":"400px","border":"1px solid #efefef","padding":"10px"},attrs:{"id":"chartId"}})
}
var staticRenderFns = []

export { render, staticRenderFns }